module.exports = __webpack_public_path__ + "static/media/sicofi.1c9084d8.png";